import React from "react";
import useSchema from "../../hooks/useSchema";

const Schema = () => {
  return (
    <script type="application/ld+json">{JSON.stringify(useSchema())}</script>
  );
};

export default Schema;
